import React from 'react';
import ReactApexChart from 'react-apexcharts';
import NoDataFound from '../../NoDataFound/NoDataFound';
import useThemeTextColor from '../../../../../utils/useThemeTextColor';
import { useTranslation } from 'react-i18next';

const CoastDistributionChart = ({ chartData }) => {
  const { t } = useTranslation();

  const textColor = useThemeTextColor();

  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const labels = chartData.map(item => item.coast || 'Other');
  const values = chartData.map(item => parseFloat(item.value.replace('%', '')));

  const backgroundColors = [
    '#4656b3', // darker #687FE5
    '#c2a9d8', // darker #EBD6FB
    '#e6a6c6', // darker #FEEBF6
    '#e89a84', // darker #FCD8CD
    '#e6e29b'  // darker #FEFBC7
  ];

  const options = {
    chart: {
      type: 'donut',
      width: '100%',
    },
    labels: labels,
    colors: backgroundColors.slice(0, chartData.length),
    title: {
      // text: t("regionalLevelSales.costDistribution"),
      align: "left",
      style: {
        fontSize: "20px",
        fontWeight: 600,
        color: "var(--heading-color)",
        fontFamily: "Quicksand"
      }
    },
    legend: {
      position: 'bottom',  
      labels: {
        colors: textColor,
        useSeriesColors: false,
      },
      markers: {
        shape: 'circle',
        size: 8
      }
    },
    tooltip: {
      y: {
        formatter: (val, { seriesIndex }) => `${val.toFixed(2)}%`
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => ``,
      style: {
        fontSize: '8px',
        fontWeight: 'bold',
        colors: ['#1a1a1a']
      },
      dropShadow: { enabled: false }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '50%',
        },
        startAngle: -90,
        endAngle: 270
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 300,height: 350 },
          legend: { position: 'bottom' }
        }
      }
    ]
  };

  return (
    <div
      style={{
        width: '100%',
        minWidth: '250px',
        maxWidth: '100%',
        height: '350px',
        padding: '0 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <ReactApexChart options={options} series={values} type="donut" height={300}/>
      </div>
    </div>
  );
};

export default CoastDistributionChart;
